export default __webpack_public_path__ + "static/media/officebadge.106ee09a.jpg";